import { AvailableGlobalPermissions, AvailablePermissionsValue, RequiredPermissions } from 'features/validateAccess';

export const DELETE_CALENDAR: RequiredPermissions = [
  [
    {
      type: 'global',
      global: AvailableGlobalPermissions.CALENDAR,
      value: AvailablePermissionsValue.DELETE,
    },
  ],
];
